import * as React from 'react'
import styled from 'styled-components'

import sanitizeHTML from '../../../services/sanitizeHTML'

import ActionButton from '../../ui/ActionButton/ActionButton'
import LinkButton from '../../ui/LinkButton/LinkButton'
import SideModal from '../../ui/SideModal/SideModal'

const StyledBanner = styled.div`
  width: 100%;
  min-height: 450px;
  background-image: ${({ background }) => `url('${background}')`};
  background-size: cover;
  background-position: center;
`

const Container = styled.div`
  padding: 0;
  display: flex;
  flex-direction: column;
  z-index: 5;
  &::before,
  &::after {
    flex: 0 0 3.75rem;
    content: '';
  }
`

const InnerContent = styled.div`
  padding: 3.75rem 3.125rem;
  background: #fff;
  border-radius: var(--border-radius-card);
  margin: 0 3.75rem;
  margin-top: -180px;
  box-shadow: var(--box-shadow-medium);
`

const Title = styled.h1`
  font-size: 1.375rem;
  font-weight: var(--font-weight-boldest);
  line-height: 1.9375rem;
  margin: 0;
  margin-bottom: 1.25rem;
`

const Schedule = styled.span`
  font-size: 0.625rem;
  line-height: 1rem;
  font-weight: var(--font-weight-boldest);
  letter-spacing: var(--letter-spacing-wide);
  padding: 7px 16px;
  max-width: 100%;
  margin: 0;
  margin-bottom: 2.1875rem;
  background: var(--color-bg);
  border-radius: var(--border-radius-small);
  color: #9b9b9b;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  text-transform: uppercase;
`

const Body = styled.div`
  > p {
    &:first-child {
      margin-top: 0;
    }
  }

  > figure {
    margin: 0;

    > img {
      max-width: 100%;
    }

    > table {
      width: 100%;
      margin: 0 -0.5rem;
      border-collapse: collapse;
      td,
      th {
        padding: 0 0.5rem;
        border: 1px solid #ccc;
      }
    }
  }

  margin-bottom: 80px;
`

const BlockActionButton = styled(ActionButton)`
  width: 100%;
`

const LinkWrapper = styled.div`
  display: flex;
  flex: 1 0 100%;
  justify-content: space-between;
  align-items: center;
`

const StyledLinkButton = styled(LinkButton)`
  width: 48%;
`

function OffersModal(props) {
  const {
    show,
    onClose,
    loading,
    data,
    advanceAccount,
    onActivate,
    onLinkCard,
    accessToken,
  } = props
  const {
    id,
    title,
    body,
    imageUrl,
    activationRequired,
    activationLeft,
    schedule,
    activated,
  } = data || {}

  return (
    <SideModal show={show} onClose={onClose} loading={loading}>
      <StyledBanner style={{ backgroundImage: `url("${imageUrl}")` }} />
      <Container>
        <InnerContent>
          <Title>{title}</Title>
          {!!schedule && <Schedule>{schedule}</Schedule>}
          <Body dangerouslySetInnerHTML={{ __html: sanitizeHTML(body) }} />
          {!!accessToken && !!activationRequired && (
            <>
              {advanceAccount ? (
                activated ? (
                  <BlockActionButton variant="primary" disabled>
                    Already Activated
                  </BlockActionButton>
                ) : activationLeft > 0 || activationLeft === -1 ? (
                  <BlockActionButton
                    variant="primary"
                    onClick={() => onActivate(id)}
                  >
                    Activate Offer
                  </BlockActionButton>
                ) : (
                  <BlockActionButton variant="primary" disabled>
                    Sold Out
                  </BlockActionButton>
                )
              ) : (
                <BlockActionButton variant="primary" onClick={onLinkCard}>
                  Link Card to Activate Offer
                </BlockActionButton>
              )}
            </>
          )}
          {!accessToken && !!activationRequired && (
            <LinkWrapper>
              <StyledLinkButton variant="primary" small to="/register">
                Join Now
              </StyledLinkButton>
              <StyledLinkButton small to="/login">
                Login
              </StyledLinkButton>
            </LinkWrapper>
          )}
        </InnerContent>
      </Container>
    </SideModal>
  )
}

export default OffersModal
